import React, { useEffect, useState } from "react";
import bitfinexLogo from "../../images/bitfinexLogo.png";
import bitmexLogo from "../../images/bitmexLogo.png";
import okxLogo from "../../images/okxLogo.png";
import binanceLogo from "../../images/binanceLogo.png";
import bybitLogo from "../../images/bybitLogo.png";
import coinbaseLogo from "../../images/coinbase.png";
import api from "../../api";
import { Loader } from "../global/loader";

const exchangeList = [
  {
    exchange: "binance",
    icon: binanceLogo,
  },
  {
    exchange: "okx",
    icon: okxLogo,
  },
];

export const Volume24H = () => {
  const [selectedExchange, setSelectedExchange] = useState("binance");
  const [exIcon, setExIcon] = useState("binance");
  const [VolumeData, setVolumeData] = useState([]);
  const [loader, setLoader] = useState(true);
  const baseUrl = `${window.location.protocol}//${window.location.host}`;

  const getVolume = async () => {
    try {
      let payload = {
        exchange: selectedExchange,
      };
      setLoader(true);
      const resp = await api.get24hVolume(payload);
      // console.log(resp);
      if (resp?.volumes) {
        setVolumeData(resp?.volumes);
      }
      setLoader(false);
    } catch (e) {
      console.log(e.message);
      setLoader(false);
    }
  };

  useEffect(() => {
    getVolume();
  }, [selectedExchange]);

  return (
    <div className="liquidityMain">
      <div className="selectCoin">
        <h5 className="me-2">24H Volume</h5>
        <div className="expand">
          <button
            className=" dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <img
              src={selectedExchange == "binance" ? binanceLogo : okxLogo}
              alt="icon"
              width={"27px"}
              style={{ marginRight: 10 }}
            />
            {selectedExchange}
          </button>
          <ul className="dropdown-menu">
            <div className="coinSelector">
              {exchangeList.map((item, key) => (
                <div
                  className="coin"
                  onClick={() => setSelectedExchange(item.exchange)}
                  key={key}
                >
                  <img
                    loading="lazy"
                    width="20"
                    src={`${item?.icon}`}
                    srcSet={`${item?.icon}`}
                    alt=""
                  />
                  <div className="name">{item.exchange}</div>
                </div>
              ))}
            </div>
          </ul>
        </div>
      </div>
      <div className="descrip mb-2">
        24 hours of buy/sell volume data for trading analysis.
      </div>
      <div className="row">
        {VolumeData.map((val, key) => (
          <div className="col-lg-4 col-sm-6 mb-3" key={key}>
            <div className="lCard">
              <div className="logo">
                <img
                  src={`${baseUrl}/icon/${val?.pair
                    .split("-")[0]
                    .toLowerCase()}.svg`}
                  alt="volume"
                />
              </div>
              <div className="content">
                <div className="title">{val?.pair}</div>
                <div className="long">${val?.buyVolumeUSDT || 0}</div>
                <div className="short">${val?.sellVolumeUSDT || 0}</div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {loader && <Loader />}
    </div>
  );
};
